package components.finishingUp

import it.neckar.commons.kotlin.js.getNotNull
import it.neckar.commons.kotlin.js.safeGet
import it.neckar.open.unit.si.ms
import it.neckar.react.common.*
import it.neckar.react.common.form.*
import react.*
import react.dom.*

val EditMessdaten: FC<EditMessdatenProps> = fc("EditMessdaten") { props ->
  val wetterbedingungen = props::wetterbedingungen.getNotNull()
  val uhrzeit = props::uhrzeit.getNotNull()
  val monteur = props::monteur.getNotNull()
  val bemerkungen = props::bemerkungen.getNotNull()
  val suffix = props::suffix.safeGet()
  val editableStatus = props::editableStatus.safeGet()


  nullableFloatingInputField(
    valueAndSetter = wetterbedingungen,
    fieldName = "wetterbedingungen$suffix",
    title = "Wetterbedingungen $suffix",
    editableStatus = editableStatus,
  ) {
    attrs {
      mergedBelow()
    }
  }

  dateTimePickerNullable(
    dateTimeState = uhrzeit,
    editableStatus = editableStatus,
  ) {
    attrs {
      mergedAbove()
      mergedBelow()
    }
  }

  nullableFloatingInputField(
    valueAndSetter = monteur,
    fieldName = "monteur$suffix",
    title = "Monteur $suffix",
    editableStatus = editableStatus,
  ) {
    attrs {
      mergedAbove()
      mergedBelow()
    }
  }

  floatingInputArea(
    valueAndSetter = bemerkungen,
    fieldName = "bemerkung$suffix",
    title = "Bemerkungen $suffix",
    editableStatus = editableStatus,
  ) {
    attrs {
      mergedAbove()
    }
  }

}

external interface EditMessdatenProps : Props {
  var wetterbedingungen: StateInstance<String?>
  var uhrzeit: StateInstance<@ms Double?>
  var monteur: StateInstance<String?>
  var bemerkungen: StateInstance<String>
  var suffix: String
  var editableStatus: EditableStatus
}
